module.exports = __webpack_public_path__ + "static/media/error.c4ac5628.png";